import BotaoPrincipal from "@/components/BotaoPrincipal";
import BotaoSecundario from "@/components/BotaoSecundario";
import BotaoText from "@/components/BotaoText";
import { ehAreaLogadaCliente, ehAreaParceiro } from "@/services/ambiente";
import { get } from "@/services/apiParceiro";
import { sleep } from "@/services/utils";
import {
  activeSpinner,
  cancelSpinner,
  setInfoDialog,
} from "@/store/reducers/geral";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ListIcon from "@mui/icons-material/List";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import DialogPriorityText from "./DialogPriorityText";
import ResultadoSimulacao from "./ResultadoSimulacao/ResultadoSimulacao";

export default function EtapaSimulacao({
  adminSimulacao,
  permiteVoltarEtapa,
  salvarSimulacao,
  setNavegarEtapa,
  dadosUsuario,
  avancarParaPagamentoAreaLogada,
  setDadosUsuario,
  carregarEtapa,
  setCarregarEtapa,
  avancarParaAutenticacao,
}) {
  const exportRef = useRef();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [carregarSimulacao, setCarregarSimulacao] = useState(false);
  const [esconderValores, setEsconderValores] = useState(false);
  const [executarSimulacao, setExecutarSimulacao] = useState(false);
  const [openDialogPriority, setOpenDialogPriority] = useState(false);
  const [comissionTableBands, setComissionTableBands] = useState([]);
  const [opcaoParcelamento, setOpcaoParcelamento] = useState({});
  const [anchorElExportarDados, setAnchorElExportarDados] = useState(null);
  const openBotaoExportarDados = Boolean(anchorElExportarDados);

  const handleClickBotaoExportarDados = (event) => {
    setAnchorElExportarDados(event.currentTarget);
  };

  const handleCloseBotaoExportarDados = () => {
    setAnchorElExportarDados(null);
  };

  const contratar = async () => {
    if (!opcaoParcelamento || adminSimulacao) {
      return;
    }
    dadosUsuario.orderSimulations = opcaoParcelamento.orderSimulations;
    dadosUsuario.billValue = opcaoParcelamento.billValue;
    dadosUsuario.tacValue = opcaoParcelamento.tacValue;
    dadosUsuario.installments = opcaoParcelamento.installments;
    dadosUsuario.interest = opcaoParcelamento.interest;
    dadosUsuario.installmentValue = opcaoParcelamento.parcel;
    dadosUsuario.discountTotal = opcaoParcelamento.discountTotal;
    dadosUsuario.cupom = formik.values.cupom || "";

    dispatch(activeSpinner());
    const result = await salvarSimulacao(dadosUsuario);
    setDadosUsuario(result);
    if (ehAreaParceiro()) {
      setNavegarEtapa(3);
    } else {
      dispatch(activeSpinner());
      await sleep(3000);
      dispatch(cancelSpinner());
      if (ehAreaLogadaCliente()) {
        avancarParaPagamentoAreaLogada();
      } else {
        avancarParaAutenticacao();
      }
    }
  };

  const Schema = Yup.object().shape({
    billValue: Yup.string().when("reverseSimulator", {
      is: "N",
      then: () => Yup.string().required("Informe o valor da simulação"),
    }),
    creditLimit: Yup.string().when("reverseSimulator", {
      is: "S",
      then: () => Yup.string().required("Informe o valor da simulação"),
    }),
  });
  const formik = useFormik({
    initialValues: {
      ...dadosUsuario,
      billValue: "",
      idComissionTable: "",
      exibirComissao: false,
      cupom: "",
      reverseSimulator: dadosUsuario.useReverseSimulator ? "S" : "N",
      creditLimit: dadosUsuario.useReverseSimulator
        ? dadosUsuario.creditLimit
        : "",
    },
    validationSchema: Schema,
    onSubmit: async (values) => {
      setExecutarSimulacao(true);
    },
  });

  const { setFieldValue } = formik;

  useEffect(() => {
    if (!executarSimulacao) {
      return;
    }
    if (!formik.values.creditLimit && !formik.values.billValue) {
      return;
    }
    setExecutarSimulacao(false);
    const values = formik.values;
    setDadosUsuario({
      ...dadosUsuario,
      billValue: values.billValue,
      creditLimit: values.creditLimit,
      idComissionTable: values.idComissionTable,
      requestPriority: values.requestPriority,
    });
    setCarregarSimulacao(true);
  }, [executarSimulacao, formik.values, setDadosUsuario, dadosUsuario]);

  useEffect(() => {
    const carregarDados = async (idComissionTable) => {
      if (dadosUsuario.cupom || dadosUsuario.couponCode) {
        setFieldValue("cupom", dadosUsuario.cupom || dadosUsuario.couponCode);
      }
      await setFieldValue("idComissionTable", idComissionTable);
      await setFieldValue(
        "requestPriority",
        dadosUsuario.requestPriority || false
      );
      await setDadosUsuario({
        ...dadosUsuario,
        idComissionTable: idComissionTable,
      });
      if (dadosUsuario.creditLimit || dadosUsuario.billValue) {
        await setFieldValue(
          "billValue",
          dadosUsuario.creditLimit || dadosUsuario.billValue
        );
        setCarregarSimulacao(true);
      }
    };
    const carregaFaixasComissionamento = async (values) => {
      try {
        dispatch(activeSpinner());
        let request = await get(`secure/commission-table`, {
          onlyActives: "Y",
        });

        dispatch(cancelSpinner());
        if (request.error) {
          dispatch(
            setInfoDialog({
              open: true,
              descricao: request.error,
            })
          );
          return;
        }
        setComissionTableBands(request);
        const idComissionTableDefault = request.find((band) => !!band.default);

        await carregarDados(idComissionTableDefault.idComissionTable);
      } catch (e) {
        console.log(e);
        dispatch(cancelSpinner());
        dispatch(
          setInfoDialog({
            open: true,
            descricao:
              "Ocorreu um erro ao simular! Tente novamente em instantes.",
          })
        );
      }
    };

    const carregarPrioridade = async () => {
      try {
        dispatch(activeSpinner());

        const result = await get(`secure/company/priority-requests`);
        dispatch(cancelSpinner());

        if (result.error) {
          dispatch({ open: true, descricao: result.error });
          return;
        }

        await setFieldValue("requestPriority", !!result.priorityRequests);

        dadosUsuario.requestPriority = !!result.priorityRequests;
      } catch (e) {
        console.error(e);
        dispatch(cancelSpinner());
        dispatch(
          setInfoDialog({
            open: true,
            descricao:
              "Houve um erro ao consultar os dados. Recarregue a página e tente novamente.",
          })
        );
      }
    };

    const carregaConfigExibirComissao = async () => {
      setFieldValue("exibirComissao", user.companyBase.displaysCommission);
    };

    if (carregarEtapa) {
      setCarregarEtapa(false);
      if (ehAreaParceiro()) {
        carregarPrioridade();
        carregaFaixasComissionamento();
        carregaConfigExibirComissao();
      } else {
        carregarDados(dadosUsuario.idComissionTable);
      }

      return;
    }
  }, [
    carregarEtapa,
    setCarregarEtapa,
    dadosUsuario,
    formik,
    user.companyBase.displaysCommission,
    setDadosUsuario,
    dispatch,
    setFieldValue,
  ]);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          container
          spacing={1}
          sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
          {ehAreaParceiro() && (
            <Grid item size={12} align="center">
              <BotaoSecundario
                id="button-options-simulacao"
                aria-controls={
                  openBotaoExportarDados ? "basic-menu" : undefined
                }
                aria-haspopup="true"
                aria-expanded={openBotaoExportarDados ? "true" : undefined}
                type="button"
                startIcon={<ListIcon />}
                onClick={handleClickBotaoExportarDados}>
                OPÇÕES
              </BotaoSecundario>
              <Menu
                id="button-options-simulacao"
                anchorEl={anchorElExportarDados}
                open={openBotaoExportarDados}
                onClose={handleCloseBotaoExportarDados}
                MenuListProps={{
                  "aria-labelledby": "button-options-simulacao",
                }}>
                <MenuItem
                  onClick={() => {
                    setEsconderValores(!esconderValores);
                  }}>
                  {esconderValores
                    ? "MOSTRAR VALORES DO PARCEIRO"
                    : "ESCONDER VALORES DO PARCEIRO"}
                </MenuItem>
              </Menu>
            </Grid>
          )}

          {!ehAreaParceiro() &&
            !dadosUsuario.idRequestCompany &&
            user.isQuitaboletos && (
              <Grid item size={12} align="center" sx={{ my: 1 }}>
                <TextField
                  name="cupom"
                  label="Cupom de desconto"
                  variant="outlined"
                  autoComplete="off"
                  value={formik.values.cupom}
                  slotProps={{ style: { textTransform: "uppercase" } }}
                  onChange={formik.handleChange}
                />
              </Grid>
            )}
          {ehAreaParceiro() && !esconderValores && (
            <>
              <Grid size={12}>
                <Grid container sx={{ flexGrow: 1, justifyContent: "center" }}>
                  <FormGroup>
                    <FormControlLabel
                      id="requestPriority"
                      name="requestPriority"
                      value={formik.values.requestPriority}
                      label="Solicitar prioridade"
                      onChange={(values, checked) => {
                        setFieldValue("requestPriority", checked);
                        setExecutarSimulacao(true);
                      }}
                      control={
                        <Switch checked={formik.values.requestPriority} />
                      }
                    />
                  </FormGroup>

                  <Grid>
                    <IconButton
                      title="Dúvidas em solicitar prioridade?"
                      color="primary"
                      onClick={() => setOpenDialogPriority(true)}
                      aria-label="priority-info">
                      <HelpOutlineIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          {!dadosUsuario.useNewSimulator && (
            <Grid size={12}>
              <Grid container sx={{ flexGrow: 1, justifyContent: "center" }}>
                {ehAreaParceiro() && !esconderValores && (
                  <Grid size={{ xs: 12, sm: 4 }} sx={{ mx: 1 }}>
                    <InputLabel shrink id="label-select-idComissionTable">
                      {"Faixa de comissionamento *"}
                    </InputLabel>
                    <Select
                      labelId="label-select-idComissionTable"
                      name="idComissionTable"
                      label={"Faixa de comissionamento *"}
                      fullWidth
                      variant="outlined"
                      value={formik.values.idComissionTable}
                      onChange={(event) => {
                        setFieldValue("idComissionTable", event.target.value);
                        setExecutarSimulacao(true);
                      }}>
                      {comissionTableBands.map((comissionTableBand) => (
                        <MenuItem
                          key={comissionTableBand.idComissionTable}
                          value={comissionTableBand.idComissionTable}>
                          {comissionTableBand.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                )}
                <Grid size={{ xs: 12, sm: 4 }} sx={{ mr: 1, ml: 1 }}>
                  {formik.values.reverseSimulator === "S" && (
                    <TextField
                      fullWidth
                      type="number"
                      sx={{ mt: 2.5 }}
                      name="creditLimit"
                      label={"Limite disponível*"}
                      onWheel={() => document.activeElement.blur()}
                      variant="outlined"
                      placeholder="R$ 0,00"
                      value={formik.values.creditLimit}
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={
                        formik.touched.creditLimit &&
                        Boolean(formik.errors.creditLimit)
                      }
                      helperText={
                        formik.touched.creditLimit && formik.errors.creditLimit
                      }
                    />
                  )}
                  {formik.values.reverseSimulator === "N" && (
                    <TextField
                      sx={{ mt: 2.5 }}
                      fullWidth
                      type="number"
                      name="billValue"
                      label={"Valor total dos boletos ou PIX*"}
                      onWheel={() => document.activeElement.blur()}
                      variant="outlined"
                      placeholder="R$ 0,00"
                      value={formik.values.billValue}
                      onChange={formik.handleChange}
                      slotProps={{
                        shrink: true,
                      }}
                      error={
                        formik.touched.billValue &&
                        Boolean(formik.errors.billValue)
                      }
                      helperText={
                        formik.touched.billValue && formik.errors.billValue
                      }
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid size={12}>
            <Grid container sx={{ flexGrow: 1, justifyContent: "center" }}>
              <BotaoPrincipal type="submit">SIMULAR NOVAMENTE</BotaoPrincipal>
            </Grid>
          </Grid>
        </Grid>
      </form>
      <div ref={exportRef}>
        <ResultadoSimulacao
          {...{
            esconderValores: esconderValores,
            exibirComissao: formik.values.exibirComissao,
            contratar,
            reverseSimulator: formik.values.reverseSimulator,
            billValue: formik.values.creditLimit || formik.values.billValue,
            table: formik.values.table,
            idCompany: formik.values.idCompany,
            cupomUtilizar: formik.values.cupom,
            idComissionTable: formik.values.idComissionTable,
            idRequest: dadosUsuario.idRequest,
            token: dadosUsuario.token,
            requestPriority: formik.values.requestPriority,
            setOpcaoParcelamento,
            carregarSimulacao,
            setCarregarSimulacao,
            exportRef,
          }}
        />

        <Grid container spacing={1} mt={1}>
          {!dadosUsuario.useNewSimulator && (
            <Grid size={{ xs: 12 }}>
              <Typography sx={{ ml: 3 }}>
                * Após selecionar a melhor condição de parcelamento, você irá
                informar os boletos ou PIX para quitarmos.
              </Typography>
            </Grid>
          )}
          {ehAreaParceiro() && (
            <Grid size={{ xs: 12 }}>
              <Typography sx={{ ml: 3 }}>
                ** Todas as operações possuem TC inclusa. Para maiores
                informações contate o suporte.
              </Typography>
            </Grid>
          )}
          {!ehAreaParceiro() && (
            <Grid size={{ xs: 12 }}>
              <Alert severity="info" sx={{ ml: 3 }}>
                <Typography>
                  Para realizar a contratação é necessário ter um{" "}
                  <b>cartão de crédito com o limite disponível.</b>
                </Typography>
              </Alert>
            </Grid>
          )}
        </Grid>
      </div>
      <Grid container spacing={3}>
        <Grid size={6}>
          {permiteVoltarEtapa() && (
            <Box>
              <BotaoText
                onClick={() => {
                  setNavegarEtapa(1);
                }}
                sx={{ mt: 3, ml: 1 }}>
                VOLTAR
              </BotaoText>
            </Box>
          )}
        </Grid>
      </Grid>

      {openDialogPriority && (
        <DialogPriorityText
          {...{ openDialogPriority, setOpenDialogPriority }}
        />
      )}
    </>
  );
}
